import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusConnector extends ToolStylus {
  static toolName = 'Connector';
  static shortcut = new Shortcut('C');

  static action({ controller }) {
    controller.actionSetStylus(controller.currentConnectorStylus);
  }
}

export default ToolStylusConnector;
